var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"pr"},[_c('section',{staticClass:"core row-between"},[(!_vm.$route.meta.hideSidebar)?_c('sidebar'):_vm._e(),_c('div',{staticClass:"defaultModel",class:{ model: !_vm.$route.meta.hideSidebar }},[_c('router-view')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }